import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = new Vuex.Store({
    state: {
        routes: [],
        locations: []
    },
    mutations: {
        addRoute(state, route) {
            state.routes.push(route);
        },
        addLocation(state, location) {
            state.locations.push(location);
        }
    },
    actions: {
        addRoute({ commit }, route) {
            commit('addRoute', route);
        },
        addRLocation({ commit }, location) {
            commit('addLocation', location);
        }
    },
    getters: {
        routes: (state) => state.routes,
        locations: (state) => state.locations
    },
    plugins: [createPersistedState(
        {
            storage: window.localStorage
        }
    )]
});

export default store;
